import { API_URL } from 'config/api';
import axios from 'axios';
import { User, UserPost } from 'types/user';

export const getUserById = async (userId: string): Promise<User> => {
  const { data } = await axios.get(`${API_URL}/user/${userId}`);
  return data.object;
};

export const postUser = async (user: UserPost) => {
  try {
    const { data } = await axios.post(`${API_URL}/user`, user);
    return data;
  } catch (err) {
    console.error('Error creating user', err);
  }
};

export const checkUsername = async (username: string) => {
  const { data } = await axios.get(
    `${API_URL}/checkUsernameExists/${username}`
  );
  return data.object;
};

export const checkEmail = async (email: string) => {
  const { data } = await axios.get(`${API_URL}/checkEmailExists/${email}`);
  return data.object;
};
